import React, { useState } from "react";
import "../App.css";
import { DxTextbox } from "genesys-react-components";
import { GenesysDevIcons } from "genesys-dev-icons";

export function ObjectSearch({
  queueValue,
  setQueueValue,
  wrapupCodeValue,
  setWrapupCodeValue,
}) {
  
  return (
    <div>
      <DxTextbox
        inputType="text"
        label="Queue Search"
        icon={GenesysDevIcons.AppSearch}
        clearButton={true}
        onChange={(value) => setQueueValue(value)}
        changeDebounceMs={500}
        // description="Search for Queues to assign the wrapup code to."
      />
      <DxTextbox
        inputType="text"
        label="Wrapup Code Search"
        icon={GenesysDevIcons.AppSearch}
        clearButton={true}
        onChange={(value) => setWrapupCodeValue(value)}
        changeDebounceMs={500}
        // description="Search for Queues to assign the wrapup code to."
      />
    </div>
  );
}